import { render, staticRenderFns } from "./SdsModal.vue?vue&type=template&id=1ce8d3fa&scoped=true"
import script from "./SdsModal.vue?vue&type=script&lang=js"
export * from "./SdsModal.vue?vue&type=script&lang=js"
import style0 from "./SdsModal.vue?vue&type=style&index=0&id=1ce8d3fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce8d3fa",
  null
  
)

export default component.exports